export const get_cookie = function (name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return parts.pop().split(';').shift();
};

export const set_cookie = function(name, value, days){
  let expires = '';
  if (days)
  {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

const get_date = function () {
  let date;
  date = new Date();
  date = date.getUTCFullYear() + '-' +
    ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
    ('00' + date.getUTCDate()).slice(-2) + ' ' +
    ('00' + date.getUTCHours()).slice(-2) + ':' +
    ('00' + date.getUTCMinutes()).slice(-2) + ':' +
    ('00' + date.getUTCSeconds()).slice(-2);
  return date;
};

export const getSendEventJson = (signup_type) => {
  let countdown_due_date = localStorage.getItem('countdown_due_date');
  let countdown_more_than_13h = null;

  if (countdown_due_date) {
    var now = new Date();
    var dueDate = new Date(countdown_due_date);

    // Compute the diff between the due date and now
    var diff = Math.max(dueDate.getTime() - now.getTime(), 0);

    var hours = Math.floor(diff / (1000 * 3600));
    countdown_more_than_13h = hours >= 13;
  }

  const body = {
    signup_type,
    signup_date: get_date(),
    yc_hash: '',
    intercom_visitor: '',
    coupon: '',
    vanity_url: '',
    social_email: get_cookie('directCheckoutEmail'),
    sign_up_method: signup_type,
    tags: [],
    role: 'public',
    user_type: '',
    start_date: '',
    end_date: '',
    utm_campaign: get_cookie('utm_campaign'),
    utm_source: get_cookie('utm_source'),
    utm_medium: get_cookie('utm_medium'),
    utm_content: get_cookie('utm_content'),
    utm_term: get_cookie('utm_term'),
    utm_audience: get_cookie('utm_audience'),
    utm_platform: get_cookie('utm_platform'),
    aff_id: get_cookie('aff_id'),
    referrer: get_cookie('utm_referrer'),
    referrer_domain: get_cookie('referrer_domain'),
    current_page: get_cookie('current_page'),
    initial_page: get_cookie('initial_page'),
    last_page: get_cookie('last_page'),
    due_date: get_cookie('countdown_due_date'),
    countdown_more_than_13h
  };

  const json = {
    signup_type,
    utm_term: body.utm_term,
    utm_audience: body.utm_audience,
    utm_platform: body.utm_platform,
    aff_id: body.aff_id,
    referrer: body.referrer,
    referrer_domain: body.referrer_domain,
    current_page: body.current_page,
    last_page: body.last_page,
    initial_page: body.initial_page,
    due_date: body.due_date ? decodeURIComponent(body.due_date) : null,
    countdown_more_than_13h: body.countdown_more_than_13h ? 'true' : 'false'
  };

  return json;
}